import React, { useState, useMemo } from 'react';
import { Typography, Button, Grid, Select, MenuItem } from '@material-ui/core';

import MemberAutocomplete from '../MemberAutocomplete';
import Modal from '../Modal/modal';

const roleTypes = ['standard', 'administrator', 'owner'];

const AddMemberModal = (props) => {
  const { title, open, onClose, members, onSave } = props;
  const [addMember, setAddMember] = useState({});
  const [roleType, setRoleType] = useState('standard');

  const disableSubmit = addMember ? !addMember.email : true;

  const closeModal = () => {
    onClose();
  };

  const addedMembers = useMemo(() => {
    if (members && members.length) {
      return members.map((member) => {
        return member.member_id;
      });
    } else {
      return [];
    }
  }, [members]);

  const isAlreadyAddedMembers = useMemo(() => {
    return (option) => addedMembers.includes(option.member_id);
  }, [addedMembers]);

  const handleSubmit = () => {
    onSave(roleType, addMember);
  };

  const handleMembersSelect = (e, v) => {
    setAddMember(v);
  };

  const handleRoleChange = (event) => {
    event.persist();
    setRoleType(event.target.value);
  };

  const ModalContent = () => (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="body1">
          Please select a member and role to add to your group
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <MemberAutocomplete
          handleChange={handleMembersSelect}
          disablerFunction={isAlreadyAddedMembers}
          label="Add Member"
          allMembers={true}
          isAddMember={true}
        />
      </Grid>
      <Grid item xs={3}>
        <Select
          label="Role"
          labelWidth={10}
          name="role type"
          className="mt-2 w-100"
          value={roleType}
          onChange={handleRoleChange}
        >
          {roleTypes.map((role) => (
            <MenuItem key={role} value={role}>
              {role}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );

  const ModalAction = () => {
    return (
      <>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => closeModal()}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disableRipple
          disabled={disableSubmit}
          onClick={handleSubmit}
        >
          Add Member
        </Button>
      </>
    );
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      title={title}
      ModalContent={ModalContent}
      ModalAction={ModalAction}
      className="add-member-modal"
    ></Modal>
  );
};

AddMemberModal.defaultProps = {
  open: false,
  onClose: null,
};

export default AddMemberModal;
